<template>
  <div class="container h-100">
    <div class="row h-100 justify-content-center align-items-center">
      <form class="col-4">
        <div class="form-group">
          <label for="emailInput">Email</label>
          <input
            v-model="email"
            :disabled="isLoading"
            type="text"
            class="form-control"
            id="emailInput"
            placeholder="email"
          />
        </div>
        <div class="form-group">
          <label for="passwordInput">Password</label>
          <input
            v-model="password"
            :disabled="isLoading"
            type="password"
            class="form-control"
            id="passwordInput"
            placeholder="password"
          />
        </div>
        <BButton
          @click.prevent="handleLogin"
          :disabled="isLoading"
          block
          pill
          variant="primary"
          type="submit"
        >
          <BSpinner v-if="isLoading" small></BSpinner>
          Login</BButton
        >
        <div class="invalid-feedback error-text">{{ error }}</div>
      </form>
    </div>
  </div>
</template>

<script>
import { BButton, BSpinner } from "bootstrap-vue";
export default {
  components: {
    BButton,
    BSpinner
  },
  data() {
    return {
      isLoading: false,
      email: "",
      password: "",
      error: undefined
    };
  },
  methods: {
    handleLogin() {
      this.toggleDisabled();
      const payload = {
        email: this.email,
        password: this.password,
        guard: "enroll_admin"
      };
      this.$http
        .post("enroll_admin/auth/login", payload)
        .then(({ data }) => {
          this.$store.dispatch("login", data);
          this.$router.push("/");
        })
        .catch(({ response }) => {
          this.error = response.data.message;
        })
        .finally(() => this.toggleDisabled());
    },
    toggleDisabled() {
      this.isLoading = !this.isLoading;
    }
  }
};
</script>

<style scoped>
.error-text {
  display: block;
}
</style>
